import { Typography } from "@mui/material";

export function MTimezoneChip({value}: {value: number}) {
  const getTimeChip = (value: number) => {
    switch (value) {
      case 0:
        return {
          color: "#1babde",
          label: "朝食",
        };
      case 1:
        return {
          color: "#fa9112",
          label: "ランチ",
        };
      case 2:
        return {
          color: "#0060df",
          label: "ディナー",
        };
    }
  };
  const timeChip = getTimeChip(value);

  return (
    <Typography
      px={1}
      variant="body2"
      sx={{
        bgcolor: timeChip?.color,
        color: "white",
        width: "max-content",
        borderRadius: 1,
      }}
    >
      {timeChip?.label}
    </Typography>
  );
}

export default MTimezoneChip;
